import { useQuery } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetConfilictInfo(id) {
  const res = await AxiosT.get(`/conflict-info?id=${id}`);
  return res.data;
}

export function useGetConfilictInfo(id) {
  return useQuery(["getConfilictInfo", id], () => fetchGetConfilictInfo(id));
}
